<template>
  <div class="wrapper fixed left-0 top-0 flex justify-center w-full h-full z-50 lg:p-3">
    <div class="modal z-20 w-full lg:w-3/6 rounded p-5" :class="$store.state.theme">
      <div class="flex justify-end">
        <icon class="text-xl cursor-pointer" icon="times" @click="$emit('close')"/>
      </div>
      <div class="flex flex-wrap justify-center items-center" @keypress.enter="saveAttribute">
        <div class="w-full flex justify-center items-center cursor-pointer py-2 text-sm">
          <span class="text-lg"><span class="text-blue-500">create new</span> {{selectedType.displayText}}</span>
          <icon class="ml-2" :icon="getIconByName(attribute.type)"/>
        </div>
        <div class="w-full lg:w-2/3 py-2">
          <input class="name w-full text-white text-xl border-0 rounded px-2" ref="newAttributeInput" v-model="attribute.name">
        </div>
        <div class="w-full bg-blue-800 lg:bg-transparent fixed z-40 lg:z-0 bottom-0 lg:relative lg:w-10 flex text-xl py-2 justify-center"
             @click="saveAttribute">
          <icon class="cursor-pointer" icon="check"/>
        </div>
        <span class="invisible lg:visible text-xs">or ENTER</span>
      </div>
      <div class="flex flex-wrap text-xl mt-5">
        <div v-for="type in types"
          :key="type.name"
          class="flex w-1/2 lg:w-1/3 my-2 cursor-pointer"
          @click="selectType(type.name)">
          <div class="w-10">
            <icon :icon="type.icon"/>
          </div>
          <div>
            <span>{{ type.displayText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      attribute: null,
      selectedType: {}
    }
  },
  beforeMount () {
    this.selectedType = this.types.find(type => type.name === 'note')
    this.attribute = {
      name: '',
      type: this.selectedType.name,
      attributes: [],
      subdocumentsIds: []
    }
    this.$nextTick(() => {
      this.$refs.newAttributeInput.focus()
    })
  },
  methods: {
    selectType (typeName) {
      this.selectedType = this.types.find(type => type.name === typeName)
      this.attribute.type = typeName
      this.$nextTick(() => {
        this.$refs.newAttributeInput.focus()
      })
    },
    saveAttribute () {
      if (this.attribute.name === '') {
        this.shakeElement(this.$refs.newAttributeInput)
        return
      }
      this.$emit('save', this.attribute)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper {
    font-family: "Roboto Light", serif;
  }
  .wrapper {
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>
